import { IControlMeetingDetailsDTO } from '../../../api/control.dao';
import { IMeetingChangeset } from '../abstract-meeting-changeset';
import { MeetingDetailsUpdateEventBody } from '../index';

export class MeetingDetailsUpdatedChangeset extends IMeetingChangeset<MeetingDetailsUpdateEventBody> {
    public applyChangesToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): Partial<IControlMeetingDetailsDTO> {
        this.updateOperatorMeetingNotes(meeting);
        this.updateMeetingProgress(meeting);
        this.updateMeetingStatus(meeting);
        this.updateOperatorSharedScreen(meeting);

        return meeting;
    }

    public getMeetingId(): number {
        return super.getChangeset().meetingId;
    }

    private updateOperatorMeetingNotes(meeting: Partial<IControlMeetingDetailsDTO>): void {
        meeting.operatorMeetingNotes = super.getChangeset().operatorMeetingNotes;
    }
    private updateMeetingProgress(meeting: Partial<IControlMeetingDetailsDTO>): void {
        meeting.progress = super.getChangeset().progress;
    }
    private updateMeetingStatus(meeting: Partial<IControlMeetingDetailsDTO>): void {
        meeting.status = super.getChangeset().status;
    }
    private updateOperatorSharedScreen(meeting: Partial<IControlMeetingDetailsDTO>): void {
        meeting.operatorSharedScreen = super.getChangeset().operatorSharedScreen;
    }
}
